import { createFileRoute } from '@tanstack/react-router';
import { StaticPage } from '../components/static/StaticPage';
import { staticHead } from '../lib/seo';
import { getStaticPage } from '../lib/static-content';

export const Route = createFileRoute('/terms')({
  head: () => {
    const p = getStaticPage('terms');
    return staticHead({ pathname: '/terms', title: p.title, description: p.metaDescription });
  },
  component: () => <StaticPage slug="terms" />,
});
